import { Shield, CheckCircle, RefreshCw } from 'lucide-react';
import { useTranslation } from '@/i18n/i18n';

export const TrustBadges = () => {
  const { t } = useTranslation();

  const badges = [
    { icon: Shield, text: t('trustBadges.officialFormulas') },
    { icon: CheckCircle, text: t('trustBadges.calculators') },
    { icon: RefreshCw, text: t('trustBadges.ratesUpdated') },
  ];

  return (
    <section className="py-6 border-y border-border/30 bg-secondary/30">
      <div className="max-w-7xl mx-auto px-6 md:px-8">
        <div className="flex flex-wrap justify-center gap-6 md:gap-12">
          {badges.map((badge) => (
            <div key={badge.text} className="flex items-center gap-2 text-sm text-muted-foreground">
              <badge.icon className="size-5 text-success" />
              <span className="font-medium">{badge.text}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
